import { connect } from 'react-redux';
import withImmutablePropsToJS from 'with-immutable-props-to-js';

import { Instances } from '../../../../constants';
import { NumberFieldNameType } from '../../../../interface';
import { IStateType } from '../../../../store/models/root.interface';
import {
    makeSelectObject,
    removeObject,
    requestLocalChangeObjectField,
    requestObject,
} from '../../../../store/Object';
import { requestObjects } from '../../../../store/Objects';
import { closeSideBar, getParams } from '../../../../store/sidebar';

import NumbersEditForm, {
    MapStatePropsType,
    DispatchPropsType,
} from '../organisms/Numbers/NumberEditForm';

const mapStateToProps = (state: IStateType) => ({
    number: makeSelectObject(Instances.whatsappNumbersView)(state) || {},
    templateData: makeSelectObject(Instances.whatsappNumbersLayout)(state) || {},
    countryList: makeSelectObject(Instances.countryList)(state) || [],
    params: getParams(state)
});

const mapDispatchToProps = (dispatch: any) => ({
    onLoad: () => dispatch((requestObject(Instances.whatsappNumbersLayout))),
    loadNumbers: () => dispatch((requestObjects(Instances.whatsappNumbers, undefined, { property: "numbers" }))),
    onChange: (fields: { name: NumberFieldNameType; value: any }) => dispatch(requestLocalChangeObjectField(Instances.whatsappNumbersView, fields)),
    onSave: (formData: any, callback: (resp: any, flag: boolean) => void) => dispatch(requestObject(Instances.whatsappNumbersEdit, undefined, undefined, 'put', true, true, formData, (response: any, flag: boolean) => callback(response, flag))),
    fetchCountryList: () => dispatch(requestObject(Instances.countryList)),
    uploadDocument: (document: any) => dispatch(requestObject(Instances.whatsappProfileUpload, undefined, undefined, 'post', true, true, document)),
    onClose: () => dispatch(closeSideBar([removeObject(Instances.whatsappNumbers)])),
});

export default connect<MapStatePropsType, DispatchPropsType, unknown, IStateType>(
    mapStateToProps,
    mapDispatchToProps
)(withImmutablePropsToJS(NumbersEditForm));
